import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { useStyles } from '../../../common/hooks';
import { connect, withBreakPoints } from '../../hoc';

import { SUBTITLE_LAYER } from '../../../common/constants';
import { MAIN_GRADIENT, MAIN_GRADIENT_AD } from '../../theme/colors';
import { AdInfos, StartScreen } from '../info';
import SectionBottom from './SectionBottom';
import SectionCenter from './SectionCenter';
import SectionOverlay from './SectionOverlay';
import SectionTop from './SectionTop';
import SeekBackground from './SeekBackground';
import SubtitleContainer from './SubtitleContainer';
import Zap from './Zap';
import {
  MAIN_WRAPPER_HIDE,
  MAIN_WRAPPER_PADDING,
  MAIN_WRAPPER_STYLE,
  UI_WRAPPER_STYLE
} from './styles';

function Main({
  UIVisible, handleTap, /* passed via InteractionHandler */
  waitStart, forceHidden, hoverTimeline,
  isAd, isTv, isSeeking, mobile, canInteract,
  small, extraSmall, zappingEnabled, isFullscreen, isAudio,
  backgroundImageSquare,
  width, height, tags, active, alignment, position
}) {
  const setStyles = useStyles();

  const WRAPPER_STYLE = useMemo(() => (isAudio
    ? {
      ...UI_WRAPPER_STYLE,
      backgroundImage: `url("${backgroundImageSquare}")`,
      backgroundSize: '40% auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      transform: 'scale(1.009)'
    }
    : UI_WRAPPER_STYLE), [backgroundImageSquare, isAudio]);

  const sectionWrapperStyles = useMemo(() => (
    {
      ...UI_WRAPPER_STYLE,
      ...(UIVisible || waitStart ? {} : { cursor: 'none', opacity: 0 }),
      ...(isAd ? { cursor: 'pointer' } : {}),
      ...(isSeeking ? { backgroundColor: 'rgba(0, 0, 0, 0.6)' } : { backgroundColor: 'transparent' })
    }
  ), [UIVisible, isAd, isSeeking, waitStart]);

  const isSectionTopHidden = useMemo(
    () => (waitStart || !canInteract)
      // Hide on xs,s in full screen when zapping enabled
      || ((isFullscreen) && zappingEnabled && (small || extraSmall)),
    [canInteract, extraSmall, isFullscreen, small, waitStart, zappingEnabled]
  );

  return (
    <div style={UI_WRAPPER_STYLE}>
      <div style={WRAPPER_STYLE}>
        <SectionOverlay
          waitStart={waitStart}
          handleTap={handleTap}
          containerVisible={UIVisible}
        />
        <SeekBackground />
        <StartScreen isMounted={waitStart} />
        <AdInfos /* timeleft and info button for mobile */ />
        {
          !waitStart && !(mobile && forceHidden)
          && (
            <div
              className="ftv-magneto--overlay"
              style={{
                ...{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  zIndex: SUBTITLE_LAYER - 1
                },
                backgroundImage: UIVisible ? ((isAd && MAIN_GRADIENT_AD) || MAIN_GRADIENT) : ''
              }}
            >
              <SubtitleContainer
                style={{
                  ...UI_WRAPPER_STYLE,
                  ...setStyles(MAIN_WRAPPER_PADDING),
                  position: 'absolute',
                  zIndex: SUBTITLE_LAYER
                }}
                sideMargin={1}
                width={width}
                height={height}
                tags={tags}
                active={!waitStart && (active && tags.length > 0)}
                alignment={alignment}
                position={position}
              />
              <div
                style={sectionWrapperStyles}
                role="presentation"
              >
                <div
                  className="ftv-magneto-main"
                  style={{
                    ...setStyles(MAIN_WRAPPER_STYLE),
                    ...!UIVisible && MAIN_WRAPPER_HIDE
                  }}
                >
                  <SectionTop
                    hidden={isSectionTopHidden}
                    containerVisible={UIVisible}
                    isTv={isTv}
                  />
                  <SectionCenter hidden={waitStart || hoverTimeline || !UIVisible} />
                  <SectionBottom hidden={waitStart || !canInteract || !UIVisible} />
                  {(UIVisible && canInteract && !waitStart) && <Zap />}
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
}

const selector = ({
  zapping: { list, zappingEnabled = list.length > 0 },
  media: { isAd, isTv, isAudio, backgroundImageSquare, isLive },
  ui: { canInteract, forceHidden, hoverTimeline, isSeeking, waitStart, isFullscreen, width, height },
  subtitles: { tags, active, alignment, position }
}) => ({
  waitStart, forceHidden, hoverTimeline,
  isAd, isTv, isSeeking, canInteract, zappingEnabled, isFullscreen,
  isAudio, backgroundImageSquare, isLive,
  width, height, tags, active, alignment, position
});

export default withBreakPoints(connect(selector)(Main));
